<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    components:{

    },
    data() {
        return {
            
        }
    },
    methods: {
       
    },
    mounted(){

    }
}
</script>


<style lang="scss">
#app,body {
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 100%;
    background: #F4F6F8;

    font-weight: 500;
    font-style: normal;
    text-transform: none;
    letter-spacing: normal;
}

// 滚动条
/* 全局滚动条宽度 */
::-webkit-scrollbar {
  width: 8px;    /* 垂直滚动条宽度 */
  height: 8px;   /* 水平滚动条高度 */
}
/* 滚动条轨道背景 */
::-webkit-scrollbar-track {
  background: #F4F6F8;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
/* hover滑块加深 */
::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
/* 滚动条边角（横竖交汇处） */
::-webkit-scrollbar-corner {
  background: #f4f4f4;
}

</style>
